import React, { useState } from "react";
import { Box, Typography, Select, MenuItem, FormControl, Divider } from "@mui/material";
import typography from "../../../cssUtils/typography";
import { selectFieldSx, labelSx, sectionLabelSx, AUDIENCE_FILTER_OPTIONS } from "../utils";

// "Audience Filter" section — UI-only preview for now (see AUDIENCE_FILTER_OPTIONS in
// ../utils.js): purely local state, never read from or sent to the server. Shared
// between WorkflowEdit (message-type bots) and CustomChatbotEdit.
const AudienceFilterEditor = () => {
  const [audience, setAudience] = useState(AUDIENCE_FILTER_OPTIONS[0].value);

  return (
    <>
      <Divider sx={{ mb: 3 }} />
      <Typography sx={sectionLabelSx}>Audience Filter</Typography>
      <Box sx={{ maxWidth: 320, mb: 3 }}>
        <Typography sx={labelSx}>Who can trigger this bot</Typography>
        <FormControl fullWidth size="small">
          <Select value={audience} onChange={(e) => setAudience(e.target.value)} sx={selectFieldSx}>
            {AUDIENCE_FILTER_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value} disabled={opt.disabled} sx={{ ...typography.bodyLarge }}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </>
  );
};

export default AudienceFilterEditor;
